// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WholesaleRouteImport } from './routes/wholesale'
import { Route as TopsRouteImport } from './routes/tops'
import { Route as TheStandardRouteImport } from './routes/the-standard'
import { Route as RangeMapRouteImport } from './routes/range-map'
import { Route as OurValuesRouteImport } from './routes/our-values'
import { Route as NewsRouteImport } from './routes/news'
import { Route as LoginRouteImport } from './routes/login'
import { Route as HeritageRouteImport } from './routes/heritage'
import { Route as FaqsRouteImport } from './routes/faqs'
import { Route as CreatorCreekRouteImport } from './routes/creator-creek'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProductsHandleRouteImport } from './routes/products.$handle'
import { Route as PoliciesYourPrivacyChoicesRouteImport } from './routes/policies.your-privacy-choices'
import { Route as PoliciesTermsOfServiceRouteImport } from './routes/policies.terms-of-service'
import { Route as PoliciesShippingPolicyRouteImport } from './routes/policies.shipping-policy'
import { Route as PoliciesRefundPolicyRouteImport } from './routes/policies.refund-policy'
import { Route as PoliciesPrivacyPolicyRouteImport } from './routes/policies.privacy-policy'
import { Route as PoliciesPrivacyConfirmRouteImport } from './routes/policies.privacy-confirm'
import { Route as CollectionsCollectionRouteImport } from './routes/collections.$collection'

const WholesaleRoute = WholesaleRouteImport.update({
            id: '/wholesale',path: '/wholesale',getParentRoute: () => rootRouteImport
          })
const TopsRoute = TopsRouteImport.update({
            id: '/tops',path: '/tops',getParentRoute: () => rootRouteImport
          })
const TheStandardRoute = TheStandardRouteImport.update({
            id: '/the-standard',path: '/the-standard',getParentRoute: () => rootRouteImport
          })
const RangeMapRoute = RangeMapRouteImport.update({
            id: '/range-map',path: '/range-map',getParentRoute: () => rootRouteImport
          })
const OurValuesRoute = OurValuesRouteImport.update({
            id: '/our-values',path: '/our-values',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const HeritageRoute = HeritageRouteImport.update({
            id: '/heritage',path: '/heritage',getParentRoute: () => rootRouteImport
          })
const FaqsRoute = FaqsRouteImport.update({
            id: '/faqs',path: '/faqs',getParentRoute: () => rootRouteImport
          })
const CreatorCreekRoute = CreatorCreekRouteImport.update({
            id: '/creator-creek',path: '/creator-creek',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProductsHandleRoute = ProductsHandleRouteImport.update({
            id: '/products/$handle',path: '/products/$handle',getParentRoute: () => rootRouteImport
          })
const PoliciesYourPrivacyChoicesRoute = PoliciesYourPrivacyChoicesRouteImport.update({
            id: '/policies/your-privacy-choices',path: '/policies/your-privacy-choices',getParentRoute: () => rootRouteImport
          })
const PoliciesTermsOfServiceRoute = PoliciesTermsOfServiceRouteImport.update({
            id: '/policies/terms-of-service',path: '/policies/terms-of-service',getParentRoute: () => rootRouteImport
          })
const PoliciesShippingPolicyRoute = PoliciesShippingPolicyRouteImport.update({
            id: '/policies/shipping-policy',path: '/policies/shipping-policy',getParentRoute: () => rootRouteImport
          })
const PoliciesRefundPolicyRoute = PoliciesRefundPolicyRouteImport.update({
            id: '/policies/refund-policy',path: '/policies/refund-policy',getParentRoute: () => rootRouteImport
          })
const PoliciesPrivacyPolicyRoute = PoliciesPrivacyPolicyRouteImport.update({
            id: '/policies/privacy-policy',path: '/policies/privacy-policy',getParentRoute: () => rootRouteImport
          })
const PoliciesPrivacyConfirmRoute = PoliciesPrivacyConfirmRouteImport.update({
            id: '/policies/privacy-confirm',path: '/policies/privacy-confirm',getParentRoute: () => rootRouteImport
          })
const CollectionsCollectionRoute = CollectionsCollectionRouteImport.update({
            id: '/collections/$collection',path: '/collections/$collection',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRoute,ContactRoute: ContactRoute,CreatorCreekRoute: CreatorCreekRoute,FaqsRoute: FaqsRoute,HeritageRoute: HeritageRoute,LoginRoute: LoginRoute,NewsRoute: NewsRoute,OurValuesRoute: OurValuesRoute,RangeMapRoute: RangeMapRoute,TheStandardRoute: TheStandardRoute,TopsRoute: TopsRoute,WholesaleRoute: WholesaleRoute,CollectionsCollectionRoute: CollectionsCollectionRoute,PoliciesPrivacyConfirmRoute: PoliciesPrivacyConfirmRoute,PoliciesPrivacyPolicyRoute: PoliciesPrivacyPolicyRoute,PoliciesRefundPolicyRoute: PoliciesRefundPolicyRoute,PoliciesShippingPolicyRoute: PoliciesShippingPolicyRoute,PoliciesTermsOfServiceRoute: PoliciesTermsOfServiceRoute,PoliciesYourPrivacyChoicesRoute: PoliciesYourPrivacyChoicesRoute,ProductsHandleRoute: ProductsHandleRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)